/* Portada «más agradable» (propuesta 3-nov-2026): lo comparten las secciones home-ag-*.
   Entrada suave al aparecer, fotos que se enfocan, flechas de los deslizables, añadir sin abrir el carrito
   y «Ahora» en las mezclas. Sin bucles ni animaciones infinitas. */
(function () {
  if (window.__agHome) return; window.__agHome = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;

  function ready(fn) { document.readyState == 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn() }

  ready(function () {
    /* fotos ya cargadas antes de que llegara este archivo */
    document.querySelectorAll('.ag-hi').forEach(function (i) { if (i.complete && i.naturalWidth) i.classList.add('is-in') });

    /* entrada suave, una sola vez */
    if (!RM && 'IntersectionObserver' in window) {
      doc.classList.add('ag-on');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-vis'); io.unobserve(e.target) } });
      }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.ag-rise').forEach(function (el) { io.observe(el) });
    }

    /* flechas de los deslizables */
    document.querySelectorAll('[data-ag-rails]').forEach(function (sec) {
      var rail = sec.querySelector('.ag-rail'), b = sec.querySelectorAll('[data-ag-step]');
      if (!rail || !b.length) return;
      function upd() {
        b.forEach(function (x) {
          var d = +x.getAttribute('data-ag-step');
          x.disabled = d < 0 ? rail.scrollLeft < 8 : rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 8;
        });
      }
      b.forEach(function (x) {
        x.addEventListener('click', function () {
          var c = rail.firstElementChild, w = c ? c.getBoundingClientRect().width + 20 : 300;
          rail.scrollBy({ left: +x.getAttribute('data-ag-step') * w * 2, behavior: RM ? 'auto' : 'smooth' });
        });
      });
      rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });

    /* «Ahora»: la tira de mezclas empieza por la de este momento del día y sigue el día */
    document.querySelectorAll('[data-ag-ahora]').forEach(function (rail) {
      var cards = [].slice.call(rail.querySelectorAll('[data-hora]'));
      if (cards.length < 2) return;
      var h = new Date().getHours() + new Date().getMinutes() / 60, best = null, bh = -1;
      cards.forEach(function (c) { var x = parseFloat(c.getAttribute('data-hora')); if (x <= h && x > bh) { bh = x; best = c } });
      if (!best) cards.forEach(function (c) { var x = parseFloat(c.getAttribute('data-hora')); if (x > bh) { bh = x; best = c } });
      var i = cards.indexOf(best);
      cards.slice(0, i).forEach(function (c) { rail.appendChild(c) });
      var spacer = rail.querySelector('.ag-end'); if (spacer) rail.appendChild(spacer);
      best.classList.add('is-now');
      rail.scrollLeft = 0; requestAnimationFrame(function () { rail.scrollLeft = 0 });
    });

    /* añadir sin abrir el carrito: el botón se pone verde y sube el contador */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ag-add]'); if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.classList.contains('is-adding')) return; btn.classList.add('is-adding');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: +btn.getAttribute('data-variant-id'), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json() })
        .then(function () {
          btn.classList.remove('is-adding'); btn.classList.add('is-added');
          var lb = btn.getAttribute('aria-label'); btn.setAttribute('aria-label', btn.getAttribute('data-added') || lb);
          setTimeout(function () { btn.classList.remove('is-added'); btn.setAttribute('aria-label', lb) }, 1800);
          if (window.fhRefreshCart) { try { var p = window.fhRefreshCart(); p && p.catch && p.catch(function () {}) } catch (er) {} }
        })
        .catch(function () { btn.classList.remove('is-adding') });
    }, true);
  });
})();
